(function () {
  function initRecipeSection(root) {
    const sliderEl = root.querySelector(".recipe-video-slider-main");
    const tabs = root.querySelectorAll(".recipe-hero-tab");
    const videoTab = root.querySelector('.recipe-hero-tab[data-recipe-tab="1"]');

    if (!tabs.length) return;

    let mySwiper = null;

    const setActiveTab = (index) => {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
      });
    };

    const mq = window.matchMedia("(min-width: 768px)");

    const initSwiper = () => {
      if (mySwiper || !sliderEl || typeof Swiper === "undefined") return;

      mySwiper = new Swiper(sliderEl, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        navigation: {
          nextEl: root.querySelector(".recipe-video-slider-arrow-right"),
          prevEl: root.querySelector(".recipe-video-slider-arrow-left"),
        },
        on: {
          init(swiper) {
            setActiveTab(swiper.realIndex);
          },
          slideChange(swiper) {
            setActiveTab(swiper.realIndex);
          },
        },
      });
    };

    const destroySwiper = () => {
      if (!mySwiper) return;
      mySwiper.destroy(true, true);
      mySwiper = null;

      // cleanup inline styles
      sliderEl.querySelectorAll(".swiper-wrapper, .swiper-slide").forEach((el) => {
        el.removeAttribute("style");
      });
      sliderEl.classList.remove("swiper-initialized");
    };

    // Desktop: tabs control swiper (prevent anchor scroll)
    const bindDesktopTabs = () => {
      tabs.forEach((tab) => {
        if (tab._tabHandler) return;
        tab._tabHandler = (e) => {
          // Only prevent default on desktop (so mobile hash scroll still works)
          e.preventDefault();

          const idx = Number(tab.dataset.recipeTab || 0);
          initSwiper();
          if (mySwiper) mySwiper.slideToLoop(idx);
        };
        tab.addEventListener("click", tab._tabHandler);
      });
    };

    const unbindDesktopTabs = () => {
      tabs.forEach((tab) => {
        if (!tab._tabHandler) return;
        tab.removeEventListener("click", tab._tabHandler);
        delete tab._tabHandler;
      });
    };

    const handle = (e) => {
      if (e.matches) {
        // desktop
        initSwiper();
        bindDesktopTabs();
      } else {
        // mobile: no swiper, let anchor hash work naturally
        unbindDesktopTabs();
        destroySwiper();

        // still set active state when clicking Video on mobile
        if (videoTab && !videoTab._mobileActiveHandler) {
          videoTab._mobileActiveHandler = () => setActiveTab(1);
          videoTab.addEventListener("click", videoTab._mobileActiveHandler);
        }
      }
    };

    handle(mq);
    if (mq.addEventListener) mq.addEventListener("change", handle);
    else mq.addListener(handle);

    // Play button logic (scoped)
    root.querySelectorAll(".recipe-video-play").forEach((btn) => {
      if (btn._playBound) return;
      btn._playBound = true;

      btn.addEventListener("click", function () {
        const wrapper = btn.closest(".recipe-video-wrapper");
        const video = wrapper?.querySelector(".recipe-video-media");
        if (video && video.paused) {
          video.play();
          video.controls = true;
          btn.style.display = "none";
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll(".recipe-ingredients").forEach((root) => initRecipeSection(root));
  }

  document.addEventListener("DOMContentLoaded", initAll);

  // Shopify theme editor support (important)
  document.addEventListener("shopify:section:load", initAll);
})();
